import { useTranslation } from 'react-i18next';
import { ListingStatus } from '@steelbuy/ts-shared';

import { Dropdown, SelectOption } from '@steelbuy/ui-primitive';
import { useMyListingsContext } from './MyListingsContext';
import { useMyPackagesContext } from '../my-packages/MyPackagesContext';

export const FILTER_CRITERIA_ID = 'filter';
export const FILTER_PROPERTY = 'status.value';

// We do not want to show drafts in the my listings overview at the moment.
// Removing the drafts in the backend would be a pretty big change and it's
// not completely clear whether we might not need the drafts in the future.
// So we don't show "Drafts" as an option in the filter and make sure that
// by default we filter for every status expect drafts.
export const MyListingsFilter = ({ isPackage = false }: { isPackage?: boolean }) => {
    const { t } = useTranslation('translation');
    const { packageFilter, setPackageFilter } = useMyPackagesContext();
    const { listingFilter, setListingFilter } = useMyListingsContext();

    const filterOptions: SelectOption[] = Object.values(ListingStatus)
        .filter((status) => status !== ListingStatus.DRAFT)
        .map((value) => ({
            label: t(`application.myListingsFilter.optionLabels.${value}`),
            value,
        }));

    const handleFilterChange = (value: string[]) => {
        if (isPackage) {
            setPackageFilter(value as ListingStatus[]);
        } else {
            setListingFilter(value as ListingStatus[]);
        }
    };

    return (
        <Dropdown
            multiselect
            title={t('application.myListingsFilter.selectLabel')}
            options={filterOptions}
            preselection={isPackage ? packageFilter : listingFilter}
            onChange={handleFilterChange}
            placeholder={t('application.myListingsFilter.selectPlaceholder')}
        />
    );
};
